"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = secp256k1Verify;

var _elliptic = _interopRequireDefault(require("elliptic"));

var _util = require("@polkadot/util");

var _expand = _interopRequireDefault(require("./expand"));

var _hasher = _interopRequireDefault(require("./hasher"));

// Copyright 2017-2020 @polkadot/util-crypto authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
const EC = _elliptic.default.ec;
const ec = new EC('secp256k1');
/**
 * @name secp256k1Verify
 * @description Verifies the signature of `message`, using the supplied pair
 */

function secp256k1Verify(message, signature, address, hashType = 'blake2', isExpanded = false) {
  const u8a = (0, _util.u8aToU8a)(signature);
  (0, _util.assert)(u8a.length === 65, `Expected signature with 65 bytes, ${u8a.length} found instead`);
  const publicKey = new Uint8Array( // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
  ec.recoverPubKey((0, _hasher.default)(hashType, message), {
    r: u8a.slice(0, 32),
    s: u8a.slice(32, 64)
  }, u8a[64]).encodeCompressed());
  return (0, _util.u8aEq)((0, _hasher.default)(hashType, isExpanded ? (0, _expand.default)(publicKey) : publicKey), (0, _util.u8aToU8a)(address));
}